<template>
    <div class="page-header">
        <div v-if="pageInfo.leftBtn" class="block-left" @click="pageInfo.leftBtn.fn()">
            <span class="f-text" v-html="pageInfo.leftBtn.beforeHtml" v-if="pageInfo.leftBtn.beforeHtml"></span>
            <i v-if="pageInfo.leftBtn.type=='icon'" :class="pageInfo.leftBtn.class"></i>
            <div v-if="pageInfo.leftBtn.type=='text'" :class="pageInfo.leftBtn.class">{{pageInfo.leftBtn.title}}</div>
            <span class="f-text" v-html="pageInfo.leftBtn.afterHtml" v-if="pageInfo.leftBtn.afterHtml"></span>
        </div>
        <div class="title" id="title">{{pageInfo.title}}</div>
        <div v-if="pageInfo.rightBtn" class="block-right" @click="pageInfo.rightBtn.fn()">
            <span class="f-text" v-html="pageInfo.rightBtn.beforeHtml" v-if="pageInfo.rightBtn.beforeHtml"></span>
            <i v-if="pageInfo.rightBtn.type=='icon'" :class="pageInfo.rightBtn.class"></i>
            <div v-if="pageInfo.rightBtn.type=='text'" :class="pageInfo.rightBtn.class">{{pageInfo.rightBtn.title}}</div>
            <span class="f-text" v-html="pageInfo.rightBtn.beforeHtml" v-if="pageInfo.rightBtn.afterHtml"></span>
        </div>
    </div>
</template>

<script>

export default {
    name: 'pageHeader',
    data() {
        return {
            pageInfo:this.pageinfo,
        };
    },
    props:{
        pageinfo:{  
            type:Object,
            default:function(){  
                return {title:'iview-admin'}  
            },
        }  
        
    },
}
</script>



// WEBPACK FOOTER //
// src/views/main_components/pageHeader.vue